import { NgModule } from '@angular/core';
import { BuBoxComponent } from './bu-box/bu-box.component';

@NgModule({
  imports: [],
  declarations: [BuBoxComponent],
  exports: [BuBoxComponent]
})
export class BuBoxModule { }
